export default {
  install(Vue: any) {
    Vue.prototype.CopySuccess = function () {
      Vue.prototype.$message.success("复制成功");
    };
    Vue.prototype.CopyError = function () {
      Vue.prototype.$message.warning("复制失败");
    };
  },
};
